
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"35","height":"35","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('circle',{attrs:{"cx":"17.5","cy":"17.5","r":"17.5","fill":"#fff"}}),_c('rect',{attrs:{"x":"13.217","y":"7.742","width":"20","height":"6","rx":"3","transform":"rotate(46.04 13.217 7.742)","fill":"#FF6A6A"}}),_c('rect',{attrs:{"x":"8.797","y":"21.805","width":"20","height":"6","rx":"3","transform":"rotate(-43.96 8.797 21.805)","fill":"#FF6A6A"}})])
          )
        }
      }
    